import React from 'react';
import { usePageProperties } from '../../../providers/PagePropertiesProvider';
import { wrapTrademarkSuperscript } from '../../../../../utils/cob-utils';
import { transformHTMLParserLinks } from '../../../../../utils/rewriteLink/rewriteLink';

export default function SecurityLinks() {

    const { learnMoreLink, learnMoreLinkText } = usePageProperties();

    let formattedLink = undefined;

    if (learnMoreLink) {
        formattedLink = learnMoreLink;
    }

    return (
        <span>
            <strong>We protect your information.</strong>{' '}
            <a
                className='Pqde-DataEntryForm__link'
                href={formattedLink}
            >
                {transformHTMLParserLinks(wrapTrademarkSuperscript(learnMoreLinkText))}
            </a>
        </span>
    );
}
